export default __webpack_public_path__ + "static/media/winMusic.5d196fa4.ogg";